import { useSiteContent } from '@/hooks/useSiteContent';
import ContentState from '@/components/feature/ContentState';

interface GreatPeopleData {
  title: string;
  highlight: string;
  description: string;
  features: { icon: string; title: string; description: string }[];
}

export default function GreatPeople() {
  const { data, loading, error, refresh } = useSiteContent<GreatPeopleData>('why_us_great_people');

  if (loading || error || !data) {
    return <ContentState loading={loading} error={error} ready={!!data} onRetry={refresh} />;
  }

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 text-center mb-4">
            {data.title}{' '}
            <span className="text-primary-500">{data.highlight}</span>
          </h2>
          <p className="text-center text-foreground-600 max-w-2xl mx-auto mb-12 md:mb-16 text-sm md:text-base">
            {data.description}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {data.features.map((feature, idx) => (
              <div key={idx} className="text-center">
                <div className="w-14 h-14 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-5">
                  <i className={`${feature.icon} text-primary-500 text-2xl`} />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-foreground-950 mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}